var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOldImportClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M21.388 12.789v6.586M23.59 27.924l3.413 5.633"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 21.296,
    cy: 24.068,
    r: 1.445
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 21.633,
    cy: 5.003,
    r: 2.86
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 21.296,
    cy: 24.068,
    r: 16.124
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 32.534,
    cy: 24.027,
    r: 0.198
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 10.349,
    cy: 24.027,
    r: 0.198
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 12.053,
    cy: 29.6,
    r: 0.198
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 12.053,
    cy: 18.652,
    r: 0.198
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 30.788,
    cy: 18.652,
    r: 0.198
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 30.788,
    cy: 29.478,
    r: 0.198
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 21.459,
    cy: 35.067,
    r: 0.198
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 16.084,
    cy: 14.453,
    r: 0.198
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 16.008,
    cy: 33.677,
    r: 0.198
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_filled",
    cx: 26.956,
    cy: 14.453,
    r: 0.198
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOldImportClock);
export default __webpack_public_path__ + "static/media/oldImportClock.7e0788f945b8e887a54163f320f3808f.svg";
export { ForwardRef as ReactComponent };